export default __webpack_public_path__ + "8b89b742488bfb29a58d3745d2b5807c.svg";